import React, { useState } from "react";

import * as emailjs from "emailjs-com";

function FormikForm() {
  const [values, setValues] = useState({
    name: null,
    email: null,
    subject: null,
    message: null,
  });

  const handleChange = (e) => {
    setValues({ [e.target.name]: e.target.value });
    console.log(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_mh4tobt",
        "template_li09kap",
        e.target,
        "user_PgZ0sFKko0nRm9OGElC9U"
      )
      .then(
        (result) => {
          console.log("email fired");
          console.log(result.status);
        },
        (error) => {
          console.log("email fired");
          console.log(error.text);
        }
      );
    resetForm();
  };

  const resetForm = () => {
    setValues({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <form onSubmit={handleSubmit} className="php-email-form mt-4">
      <div className="form-row">
        <div className="col-md-6 form-group">
          <input
            type="text"
            name="name"
            className="form-control"
            id="name"
            placeholder="Your Name"
            defaultValue={values.name}
            onChange={handleChange}
            required
          />
          {/* <div className="validate"></div> */}
        </div>
        <div className="col-md-6 form-group">
          <input
            type="email"
            className="form-control"
            name="email"
            id="email"
            placeholder="Your Email"
            defaultValue={values.email}
            onChange={handleChange}
            required
          />
          {/* <div className="validate"></div> */}
        </div>
      </div>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          name="subject"
          id="subject"
          placeholder="Subject"
          defaultValue={values.subject}
          onChange={handleChange}
          required
        />
        {/* <div className="validate"></div> */}
      </div>
      <div className="form-group">
        <textarea
          className="form-control"
          name="message"
          rows="5"
          data-rule="required"
          defaultValue={values.message}
          onChange={handleChange}
          required
        ></textarea>
        {/* <div className="validate"></div> */}
      </div>
      {/* <div className="mb-3">
        <div className="loading">Loading</div>
        <div className="error-message"></div>
        <div className="sent-message">
          Your message has been sent. Thank you!
        </div>
      </div> */}
      <div className="text-center">
        <button type="submit">Send Message</button>
      </div>
    </form>
  );
}

export default FormikForm;
